import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import GenericTableTemplate from 'Views/Page/Content/Templates/GenericTableTemplate';
import ManagedAccountModelUpdateRequestWithTabs
  from 'Views/Page/Content/Templates/ManagedAccountModelUpdateRequestPageTemplate/ManagedAccountModelUpdateRequestWithTabs';

const ManagedAccountModelUpdateRequestPageTemplate = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.modelUpdateRequestUpdates.name]: (<ManagedAccountModelUpdateRequestWithTabs />),
  }, <GenericTableTemplate />);
};

ManagedAccountModelUpdateRequestPageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
ManagedAccountModelUpdateRequestPageTemplate.defaultProps = {};

export default ManagedAccountModelUpdateRequestPageTemplate;
